import { Project } from '@/models/Project';
import { ROUTES } from '@/utils/routes';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import Banner from './Banner';
import CompleteOwners from './CompleteOwners';
import FlexGroup from './FlexGroup';
import HackathonActionFactory from './HackathonClassification';
import Interactions from './Interactions';
import OwnerActions from './OwnerActions';
import Owners from './Owners';
import { ProjectTags } from './ProjectTags';
import ProjectUnit from './ProjectUnit';
import PublishDate from './PublishDate';
import Ranking from './Ranking';
import CardSkeleton from './Skeleton';
import Title from './Title';
import HackathonVotingAction from './HackathonVotingAction';

export default function Card({
  children,
  className,
  project,
}: PropsWithChildren<{ project: Project; className?: string }>) {
  const navigate = useNavigate();
  return (
    <li
      className={twMerge(
        'relative p-2 rounded-lg min-w-72 w-72 xl:min-w-80 bg-base-100 shadow-default snap-center sm:snap-none border border-neutral-content',
        className,
      )}
    >
      <div
        onClick={() =>
          navigate(ROUTES.PROJECTS.INFO(project.id), { state: project })
        }
        className="flex flex-col h-full gap-2.5 cursor-pointer"
      >
        {children}
      </div>
    </li>
  );
}

Card.FlexGroup = FlexGroup;
Card.Tags = ProjectTags;
Card.Banner = Banner;
Card.Title = Title;
Card.Interactions = Interactions;
Card.PublushDate = PublishDate;
Card.Owners = Owners;
Card.CompleteOwners = CompleteOwners;
Card.HackathonActionFactory = HackathonActionFactory;
Card.HackathonVotingAction = HackathonVotingAction;
Card.OwnerActions = OwnerActions;
Card.Ranking = Ranking;
Card.Skeleton = CardSkeleton;
Card.Unit = ProjectUnit;
